import { render, staticRenderFns } from "./CustomWishes.vue?vue&type=template&id=dd3bfa7a"
import script from "./CustomWishes.vue?vue&type=script&lang=js"
export * from "./CustomWishes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports